import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface Applicant {
    applicantId: string;
}

const initialState: Applicant = {
    applicantId: ''
}


export const applicantSlice = createSlice({
    name: 'applicantId',
    initialState,
    reducers: {
        updateApplicantId: (state, action: PayloadAction<Applicant>) => {
            state.applicantId = action.payload.applicantId;
        }
    }
});


export const {updateApplicantId} = applicantSlice.actions;

export default applicantSlice.reducer;